import { useContext } from 'react';
import {
    LocationAnalyticsContext,
    LocationAnalyticsContextData
} from './context';

export function useLocationAnalytics(): LocationAnalyticsContextData {
    const data = useContext<LocationAnalyticsContextData | undefined>(
        LocationAnalyticsContext
    );

    if (!data) {
        throw new Error(
            "LocationAnalyticsContext unavailable. Are you sure you're using this in a nested component of an LocationAnalyticsProvider?"
        );
    }

    return data;
}
